export function FormatSize(size: number | undefined): string {
    if (size === undefined || size == 0) {
        return "1 KB";
    } else if (size < Math.pow(2, 10)) {
        return size.toString() + " B";
    } else if (size < Math.pow(2, 20)) {
        return Math.round(size / Math.pow(2, 10)).toString() + " KB";
    } else {
        return Math.round(size / Math.pow(2, 20)).toString() + " MB";
    }
}

export function truncateFileName(fileName: string, maxLength: number = 127): string {
    if (fileName.length <= maxLength) {
        return fileName;
    }

    const lastDot = fileName.lastIndexOf(".");
    if (lastDot <= 0) {
        return fileName.slice(0, maxLength);
    }

    const extension = fileName.slice(lastDot);
    const baseName = fileName.slice(0, lastDot);
    const maxBaseLength = maxLength - extension.length;

    if (maxBaseLength <= 0) {
        return extension.slice(0, maxLength);
    }

    return baseName.slice(0, maxBaseLength) + extension;
}

export function updateParagraphStyles(html: string): string {
    // Parse the HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Find all <p> tags
    const paragraphs = doc.querySelectorAll("p");

    paragraphs.forEach(p => {
        const existingStyle = p.getAttribute("style") || "";

        // Split styles into key/value pairs
        const styleMap = new Map<string, string>();

        existingStyle
            .split(";")
            .map(s => s.trim())
            .filter(Boolean)
            .forEach(style => {
                const [key, ...valueParts] = style.split(":");
                if (!key || valueParts.length === 0) return;

                styleMap.set(key.trim().toLowerCase(), valueParts.join(":").trim());
            });

        // Replace margin + padding
        styleMap.set("margin", "0px");
        styleMap.set("padding", "0px");

        // Remove individual margin-* and padding-* properties
        [
            "margin-top",
            "margin-right",
            "margin-bottom",
            "margin-left",
            "padding-top",
            "padding-right",
            "padding-bottom",
            "padding-left",
        ].forEach(prop => styleMap.delete(prop));

        // Rebuild style string
        const newStyle = Array.from(styleMap.entries())
            .map(([key, value]) => `${key}:${value}`)
            .join("; ");

        p.setAttribute("style", newStyle);
    });

    return doc.body.innerHTML;
}
